var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlikeActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,40.693359375,42)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.3859566875,38.99995C20.8119798275,38.99995,20.3466796875,38.534651,20.3466796875,37.960674L20.3466796875,28.6071815C20.3466796875,28.0332046,20.8119798275,27.567904900000002,21.3859564875,27.567904900000002L23.4970702875,27.567904900000002L23.4970702875,38.999428L24.5363473875,38.999428L24.5363473875,27.5673828L24.505526987499998,27.5673828Q28.9013604875,26.247823699999998,29.577334387500002,21.95237529C29.6974372875,21.189188,30.5105026875,20.69774938,31.0878976875,21.21106714C32.8189836875,22.7500458,32.6281776875,24.7162271,32.2248096875,26.1892018C32.0374576875,26.873357300000002,32.522929687499996,27.5411568,33.2310736875,27.4998879C34.9212386875,27.4013906,36.5723896875,27.4315834,36.9751086875,29.6465626Q37.4733126875,32.386705,34.1502966875,38.470366999999996C33.9699696875,38.800503,33.6242996875,39.00005,33.2481266875,39.000046L24.5037870875,38.99995L21.3859566875,38.99995Z",
    fillRule: "evenodd",
    fill: "#004CD3",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlikeActiveIcon);
export default __webpack_public_path__ + "static/media/unlike-active-icon.5dcf6ff6e66b6f05f9fa5d79d8d4c1ae.svg";
export { ForwardRef as ReactComponent };